export const configure = {
  show: {
    model: {
      title: "模型",
      model: [],
    },
    kml: {
      title: "kml",
      model: [],
    },
    shp: {
      title: "shp",
      model: [],
    },
    plot: {
      title: "标绘",
      model: [],
    },
    pit: {
      title: "地形修改",
      model: [],
    },
  },
  hide: {
    model: {
      title: "模型",
      model: [],
    },
    kml: {
      title: "kml",
      model: [],
    },
    shp: {
      title: "shp",
      model: [],
    },
    plot: {
      title: "标绘",
      model: [],
    },
    pit: {
      title: "地形修改",
      model: [],
    },
  },
  flight: {
    flight: {
      title: "移动",
      model: [],
    },
  },
  underground: {
    opacity: {
      title: "环境透明度",
      model: 1,
    },
  },
  dyeing: {
    model: {
      title: "模型着色",
      model: {
        x: [],
        y: [],
      },
    },
  },
  animation: {
    animation: {
      title: "施工模拟",
      model: [],
    },
  },
  fixedRoute: {
    fixedRoute: {
      title: "交通模拟",
      model: [],
    },
  },
  sectioning: {
    sectioning: {
      title: "模型剖切",
      model: [],
    },
  },
  terrain: {
    terrain: {
      title: "地形服务",
      model: {
        x: [],
        y: [],
      },
    },
  },
};

export const typeCorrespondence = {
  show: {
    label: "显示",
    class: "el-link el-link--primary",
    type: "usually",
  },
  hide: {
    label: "隐藏",
    class: "el-link el-link--danger",
    type: "usually",
  },
  flight: {
    label: "移动",
    class: "el-link el-link--success",
    type: "usually",
  },
  dyeing: {
    label: "模型着色",
    class: "el-link el-link--warning",
    type: "usually",
  },
  opacity: {
    label: "透明",
    class: "el-link el-link--warning",
    type: "usually",
  },
  roaming: {
    label: "漫游",
    class: "el-link el-link--warning",
    type: "usually",
  },
  split: {
    label: "卷帘",
    class: "el-link el-link--warning",
    type: "usually",
  },
};
